(function ($) {
    $(document).ready(function () {
        console.log("ready");

        createSelectpicker("select");
    });

    $(document).on("ajaxComplete", function (event, xhr, settings) {
        createSelectpicker(".orderby");
    });

    function createSelectpicker(element) {
        $(element).wrap("<div class='position-relative'></div>");
        // let parent = $(element).parent()[0];

        new SlimSelect({
            select: element,
            settings: {
                showSearch: false,
                // contentLocation: parent,
            },
        });
    }
})(jQuery);
